import type { ComponentType } from 'react';
import type { NewsKind } from '@skystone/shared';
import {
  ArrowPathIcon,
  CheckCircleIcon,
  MegaphoneIcon,
  TagIcon,
  WrenchIcon,
} from '@/components/ui/icons';

export interface NewsKindIconProps {
  className?: string;
}

/**
 * Maps each NewsKind to the icon component that should render for it on the
 * homepage feed and in the admin kind-picker.
 *
 * Source-of-truth for the icon mapping. NEWS_KIND_META in @skystone/shared
 * carries the icon NAME (string); this map turns the name into a renderable
 * React component (which can't live in shared because shared is FE/BE-agnostic).
 */
export const NEWS_KIND_ICON: Record<NewsKind, ComponentType<NewsKindIconProps>> = {
  RELEASED: CheckCircleIcon,
  PATCHED: WrenchIcon,
  UPDATED: ArrowPathIcon,
  RENAMED: TagIcon,
  ANNOUNCEMENT: MegaphoneIcon,
};
